// D8 — App-side self-add of permanent family members over the
// /families/:familyId/members surface (App Backend).
//
// API contract:
//   POST   /families/:familyId/members        → { member: { id } }
//   PATCH  /families/:familyId/members/:id     → 204
//   DELETE /families/:familyId/members/:id     → 204
//
// All routes require auth + 404 (anti-enumeration) when the
// `selfAddMembers` feature flag is off on the backend.

import api from './api';

export interface CreateMemberBody {
  firstName: string;
  lastName: string;
  relationship: string;
  dob?: string;
  phone?: string | null;
  email?: string | null;
  dietaryRequirements?: string | null;
  gender?: string;
}

export const createMember = (familyId: string, body: CreateMemberBody) =>
  api
    .post<{ member: { id: string } }>(`/families/${familyId}/members`, body)
    .then((r) => r.data);

export const updateMember = (
  familyId: string,
  id: string,
  patch: Partial<CreateMemberBody>,
) =>
  api
    .patch<void>(`/families/${familyId}/members/${id}`, patch)
    .then(() => undefined);

export const deleteMember = (familyId: string, id: string) =>
  api.delete<void>(`/families/${familyId}/members/${id}`).then(() => undefined);
